/** Convert a positive integer to Roman numerals (uppercase). Returns empty
 *  string for zero or negatives. */
export function intToRoman(n: number): string {
  if (n <= 0) return '';
  const map: [number, string][] = [
    [1000, 'M'],
    [900, 'CM'],
    [500, 'D'],
    [400, 'CD'],
    [100, 'C'],
    [90, 'XC'],
    [50, 'L'],
    [40, 'XL'],
    [10, 'X'],
    [9, 'IX'],
    [5, 'V'],
    [4, 'IV'],
    [1, 'I'],
  ];
  return map.reduce<{ result: string; remaining: number }>(
    (acc, [val, roman]) => {
      const count = Math.floor(acc.remaining / val);
      return {
        result: acc.result + roman.repeat(count),
        remaining: acc.remaining - count * val,
      };
    },
    { result: '', remaining: n }
  ).result;
}

/** Convert a 0-based index to a lowercase letter sequence: 0=a, 25=z, 26=aa,
 *  27=ab… Used by section rows for sub-item ordinal labels. */
export function indexToLetter(idx: number): string {
  let result = '';
  let n = idx;
  do {
    result = String.fromCharCode(97 + (n % 26)) + result;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return result;
}

/** Convert a SCREAMING_SNAKE_CASE backend enum value into a human-readable
 *  Title Case label (e.g. "AORTIC_VALVE" → "Aortic Valve"). */
export function humanizeClass(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
